/**
 * Standard-Texte für Impressum und Datenschutz als Markdown-Vorlage.
 * Werden verwendet:
 *  - im LegalContactManager als "Vorlage einfügen"-Text
 *  - als Fallback auf den öffentlichen Seiten, wenn die DB (settings.legal_impressum /
 *    settings.legal_datenschutz) noch leer ist.
 * Änderungen der Praxis werden über den Admin-Bereich in der DB gespeichert und überschreiben
 * dann diese Defaults.
 */

export const DEFAULT_IMPRESSUM = `## Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)

Praxis für Frauenheilkunde und Geburtshilfe
Dr. med. Inka Scheer
Nibelungenstraße 40a
68642 Bürstadt
Deutschland

## Kontakt

Telefon: 06206 – 96 33 20
Fax: 06206 – 70 74 51
E-Mail: [info@praxis-scheer.de](mailto:info@praxis-scheer.de)

## Verantwortlich für den Inhalt gemäß § 18 Abs. 2 Medienstaatsvertrag (MStV)

Dr. med. Inka Scheer
Nibelungenstraße 40a
68642 Bürstadt

## Berufsrechtliche Angaben

**Berufsbezeichnung**
Fachärztin für Frauenheilkunde und Geburtshilfe
Die Berufsbezeichnung wurde in der Bundesrepublik Deutschland verliehen.

**Zuständige Ärztekammer**
Landesärztekammer Hessen
Im Vogelsgesang 3
60488 Frankfurt am Main
Postfach 90 06 69
60446 Frankfurt am Main
Telefon: 069 97672-0
Website: [www.laekh.de](https://www.laekh.de)

**Zuständige Kassenärztliche Vereinigung**
Kassenärztliche Vereinigung Hessen
Georg-Voigt-Straße 15
60325 Frankfurt am Main
Telefon: 069 79502-0
Website: [www.kvhessen.de](https://www.kvhessen.de)

**Berufsrechtliche Regelungen**
Es gelten insbesondere folgende berufsrechtliche Regelungen:

- Berufsordnung für Ärztinnen und Ärzte der Landesärztekammer Hessen
- Heilberufsgesetz des Landes Hessen

Die aktuellen Fassungen der berufsrechtlichen Regelungen finden Sie auf der Website der Landesärztekammer Hessen: [www.laekh.de](https://www.laekh.de)

## Berufshaftpflichtversicherung

**R+V Versicherung AG**
Raiffeisenplatz 1
65189 Wiesbaden

E-Mail: [ruv@ruv.de](mailto:ruv@ruv.de)
Website: [www.ruv.de](https://www.ruv.de)
Telefon: [0800 – 533 1118](tel:008005331118)

**Geltungsbereich:** Deutschland

## Technische Umsetzung und Betreuung der Website

CLICK GROUP MEDIA
Schrobenhausen
Website: [www.click-group.media](https://www.click-group.media)

## Haftung für Inhalte

Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir übernehmen jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte.

Nach §§ 8 bis 10 DDG besteht keine Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder aktiv nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.

Eine Haftung ist erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte unverzüglich entfernen.

Die auf dieser Website bereitgestellten Informationen dienen der allgemeinen Orientierung und ersetzen keine individuelle ärztliche Beratung oder Behandlung. Trotz sorgfältiger Pflege der Inhalte können medizinische Erkenntnisse sich weiterentwickeln. Bei gesundheitlichen Fragen wenden Sie sich bitte direkt an uns oder an einen Arzt Ihres Vertrauens.

## Haftung für Links

Unsere Website enthält gegebenenfalls Links zu externen Websites Dritter. Auf deren Inhalte haben wir keinen Einfluss und übernehmen hierfür keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.

Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zu diesem Zeitpunkt nicht erkennbar. Eine permanente Kontrolle der verlinkten Seiten ist ohne konkrete Hinweise auf eine Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir entsprechende Links unverzüglich entfernen.

## Urheberrecht

Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung oder jede andere Art der Verwertung außerhalb der Grenzen des Urheberrechts bedarf der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.

Soweit Inhalte auf dieser Website nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet und entsprechend gekennzeichnet. Sollten Sie dennoch auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir entsprechende Inhalte entfernen.

## Bildnachweis

Die auf dieser Website verwendeten Bilder wurden erstellt von:

Marc Fippel Fotografie
Website: [marcfippel.de](https://marcfippel.de)

Die Nutzung der Bilder erfolgt mit entsprechender Genehmigung bzw. im Rahmen der bestehenden Nutzungsrechte.

## Datenschutz

Informationen zur Verarbeitung personenbezogener Daten finden Sie in unserer [Datenschutzerklärung](/datenschutz).
`;

export const DEFAULT_DATENSCHUTZ = `## 1. Datenschutz auf einen Blick

Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung (DSGVO).

Diese Datenschutzerklärung informiert Sie darüber, welche personenbezogenen Daten beim Besuch unserer Website sowie im Rahmen unserer ärztlichen Tätigkeit verarbeitet werden und welche Rechte Ihnen zustehen.

## 2. Verantwortliche Stelle

Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website sowie in unserer Praxis ist:

Dr. med. Inka Scheer
Praxis für Frauenheilkunde und Geburtshilfe
Nibelungenstrasse 40a
68642 Bürstadt

**Kontakt:**
Telefon: 0 6206 – 96 33 20
Fax: 0 6206 – 70 74 51
E-Mail: [info@praxis-scheer.de](mailto:info@praxis-scheer.de)

## 3. Verarbeitung personenbezogener Daten im Rahmen der ärztlichen Behandlung

Im Rahmen unserer gynäkologischen Tätigkeit verarbeiten wir personenbezogene Daten unserer Patientinnen. Hierzu gehören insbesondere:

- Name und Kontaktdaten
- Geburtsdatum
- Versicherungsdaten
- medizinische Vorgeschichte
- Untersuchungsergebnisse
- Diagnosen
- Therapie- und Behandlungsinformationen

Die Verarbeitung erfolgt zur:

- Durchführung medizinischer Untersuchungen und Behandlungen
- Dokumentation der Behandlung
- Kommunikation mit Patientinnen
- Abrechnung mit Krankenversicherungen
- Erfüllung gesetzlicher Dokumentationspflichten

Gesundheitsdaten gehören zu den besonders geschützten personenbezogenen Daten gemäß Art. 9 DSGVO. Die Verarbeitung erfolgt gemäß Art. 9 Abs. 2 lit. h DSGVO sowie den geltenden gesetzlichen Regelungen für Ärztinnen und Ärzte. Alle Mitarbeiterinnen und Mitarbeiter unterliegen der ärztlichen Schweigepflicht.

## 4. Datenerfassung beim Besuch unserer Website

Beim Besuch unserer Website werden automatisch Informationen durch den Server verarbeitet. Dies können sein:

- IP-Adresse
- Datum und Uhrzeit des Zugriffs
- Browsertyp und Browserversion
- Betriebssystem
- Referrer-Adresse
- besuchte Seiten

Diese Daten werden zur technischen Bereitstellung, Sicherheit und Optimierung unserer Website verarbeitet. Eine Zusammenführung mit anderen Datenquellen erfolgt nicht. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.

## 5. Cookies und Consent-Management

Unsere Website verwendet Cookies und vergleichbare Technologien. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und bestimmte Funktionen der Website ermöglichen.

Wir unterscheiden zwischen:

**Technisch notwendigen Cookies**
Diese Cookies sind erforderlich, damit unsere Website technisch funktioniert.

**Analyse- und Drittanbieter-Dienste**
Dienste wie Google Analytics oder Google Maps werden erst aktiviert, wenn Sie hierzu über unser Cookie-Banner Ihre Einwilligung erteilen.

Zur Verwaltung Ihrer Cookie-Einstellungen verwenden wir eine eigene Consent-Lösung, die auf unserem eigenen Server betrieben wird. Ihre Auswahl wird ausschließlich lokal in Ihrem Browser gespeichert; dabei werden keine Daten an Drittanbieter übertragen. Sie können Ihre Cookie-Einstellungen jederzeit über den Link „Cookie-Einstellungen“ im Fußbereich dieser Website ändern oder Ihre Einwilligung mit Wirkung für die Zukunft widerrufen.

## 6. Google Analytics 4

Diese Website nutzt Google Analytics 4, einen Webanalysedienst der:

Google Ireland Limited
Gordon House
Barrow Street
Dublin 4
Irland

Google Analytics verwendet Cookies und ähnliche Technologien, um die Nutzung unserer Website zu analysieren. Dabei können insbesondere folgende Informationen verarbeitet werden:

- aufgerufene Seiten
- Nutzung der Website
- technische Informationen zum Endgerät
- Browserinformationen
- ungefähre Standortinformationen
- Interaktionen mit der Website

Google Analytics wird erst nach Ihrer ausdrücklichen Einwilligung über unser Cookie-Consent-System aktiviert. Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.

**Datenübertragung in die USA**

Bei der Nutzung von Google Analytics können Daten an Server der Google LLC in den USA übertragen und dort verarbeitet werden. Die USA gelten datenschutzrechtlich als Drittland mit einem im Vergleich zur Europäischen Union abweichenden Schutzniveau. Google LLC ist unter dem EU-US Data Privacy Framework zertifiziert (Angemessenheitsbeschluss der EU-Kommission vom 10. Juli 2023), sodass die Übertragung auf Grundlage von Art. 45 DSGVO erfolgt. Ergänzend hat Google Standardvertragsklauseln gemäß Art. 46 Abs. 2 lit. c DSGVO zugesichert.

**IP-Anonymisierung**

Auf dieser Website ist die IP-Anonymisierung aktiviert. Google Analytics 4 speichert keine vollständigen IP-Adressen; Ihre IP-Adresse wird vor jeder Auswertung gekürzt bzw. anonymisiert. Ein direkter Personenbezug der Statistikdaten ist damit ausgeschlossen.

**Speicherdauer der Statistikdaten**

Die über Google Analytics erhobenen Nutzungsdaten werden für bis zu 14 Monate gespeichert und anschließend automatisch gelöscht. Ausgewertet werden ausschließlich aggregierte Statistiken.

**Widerruf und Widerspruch**

Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie Ihre Auswahl über den Link „Cookie-Einstellungen“ im Fußbereich dieser Website ändern. Zusätzlich können Sie die Erfassung durch Google Analytics mit dem Browser-Add-on von Google deaktivieren: [tools.google.com/dlpage/gaoptout](https://tools.google.com/dlpage/gaoptout?hl=de)

Eine aktive Auswertung personenbezogener Daten durch unsere Praxis erfolgt nicht. Die Verarbeitung erfolgt ausschließlich zur technischen Analyse und Verbesserung unseres Webangebotes.

Weitere Informationen zum Datenschutz bei Google: [policies.google.com/privacy](https://policies.google.com/privacy)

## 7. Google Maps

Diese Website nutzt Google Maps zur Darstellung unseres Praxisstandortes. Die Karte wird über eine Zwei-Klick-Lösung eingebunden. Vor Aktivierung der Karte erfolgt keine Verbindung zu Google. Erst durch Ihre aktive Zustimmung bzw. Ihren Klick auf die Kartenansicht wird eine Verbindung zu Google hergestellt.

**Anbieter:**
Google Ireland Limited
Gordon House
Barrow Street
Dublin 4
Irland

Dabei können technische Daten, insbesondere Ihre IP-Adresse, an Google übertragen werden.

Auch bei der Nutzung von Google Maps können Daten an die Google LLC in den USA übertragen werden. Google LLC ist unter dem EU-US Data Privacy Framework zertifiziert, sodass die Übertragung auf Grundlage von Art. 45 DSGVO erfolgt.

Weitere Informationen: [policies.google.com/privacy](https://policies.google.com/privacy)

## 8. Schriftarten (lokal gehostet)

Die auf dieser Website verwendeten Schriftarten sind lokal auf unserem Server gespeichert und werden direkt von dort geladen. Beim Aufruf der Website wird keine Verbindung zu Servern von Google oder anderen Drittanbietern aufgebaut; es werden dabei keine personenbezogenen Daten wie Ihre IP-Adresse an Dritte übertragen.

## 9. Externe Bilder und Bildnachweise

Auf unserer Website werden Bilder verwendet, die teilweise durch externe Anbieter beziehungsweise Fotografen bereitgestellt wurden.

**Bildnachweis:**
Marc Fippel Fotografie
Website: [marcfippel.de](https://marcfippel.de)

Bei der Darstellung der Bilder werden keine personenbezogenen Daten von Besucherinnen und Besuchern verarbeitet, sofern keine externen Dienste des jeweiligen Anbieters eingebunden werden.

## 10. Kontaktaufnahme per E-Mail

Eine Kontaktaufnahme über ein Kontaktformular ist nicht möglich. Sollten Sie uns per E-Mail kontaktieren, werden Ihre Angaben ausschließlich zur Bearbeitung Ihrer Anfrage verarbeitet.

Bitte beachten Sie, dass eine unverschlüsselte E-Mail-Kommunikation keinen vollständigen Schutz sensibler medizinischer Informationen gewährleisten kann. Bitte übermitteln Sie keine vertraulichen Gesundheitsdaten unverschlüsselt per E-Mail.

## 11. Speicherdauer

Wir speichern personenbezogene Daten nur solange, wie dies für die jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Medizinische Dokumentationen werden entsprechend den gesetzlichen Vorgaben für ärztliche Unterlagen aufbewahrt. Nach Ablauf dieser Fristen werden Daten gelöscht oder entsprechend den gesetzlichen Anforderungen gesperrt.

## 12. Bewerbungen und Bewerberdaten

Wenn Sie sich bei uns bewerben, verarbeiten wir die von Ihnen übermittelten personenbezogenen Daten zum Zweck der Durchführung des Bewerbungsverfahrens. Dies betrifft insbesondere:

- Name und Kontaktdaten
- Bewerbungsunterlagen (z. B. Lebenslauf, Zeugnisse und Qualifikationsnachweise)
- Angaben zu Ihrer beruflichen Qualifikation und Ihrem bisherigen Werdegang
- Informationen aus der Kommunikation im Rahmen des Bewerbungsprozesses

Die Verarbeitung erfolgt ausschließlich zur:

- Prüfung Ihrer Bewerbung
- Durchführung des Bewerbungsverfahrens
- Entscheidung über die Begründung eines Beschäftigungsverhältnisses

Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO in Verbindung mit § 26 Bundesdatenschutzgesetz (BDSG).

Bewerbungsdaten werden vertraulich behandelt und ausschließlich von den Personen verarbeitet, die am Bewerbungsprozess beteiligt sind. Eine Weitergabe Ihrer Bewerbungsdaten an Dritte erfolgt nicht.

Sofern Bewerbungsunterlagen besondere Kategorien personenbezogener Daten gemäß Art. 9 DSGVO enthalten, beispielsweise Gesundheitsdaten, erfolgt die Verarbeitung nur, soweit dies gesetzlich zulässig ist oder eine ausdrückliche Einwilligung vorliegt.

Nach Abschluss des Bewerbungsverfahrens werden Ihre Daten gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen oder Sie einer weiteren Speicherung ausdrücklich zugestimmt haben.

Sollten wir Ihre Bewerbung für zukünftige Stellenangebote berücksichtigen möchten, erfolgt eine längere Speicherung Ihrer Daten ausschließlich mit Ihrer vorherigen Einwilligung. Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen.

## 13. Ihre Rechte

Sie haben folgende Rechte:

- Recht auf Auskunft gemäß Art. 15 DSGVO
- Recht auf Berichtigung gemäß Art. 16 DSGVO
- Recht auf Löschung gemäß Art. 17 DSGVO
- Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO
- Recht auf Datenübertragbarkeit gemäß Art. 20 DSGVO
- Recht auf Widerspruch gemäß Art. 21 DSGVO

Sie können eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.

## 14. Beschwerderecht bei einer Aufsichtsbehörde

Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.

## 15. Ansprechpartner Datenschutz

Bei Fragen zum Datenschutz wenden Sie sich bitte an:

Dr. med. Inka Scheer
[info@praxis-scheer.de](mailto:info@praxis-scheer.de)

## 16. Aktualisierung dieser Datenschutzerklärung

Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn rechtliche, technische oder organisatorische Änderungen dies erforderlich machen.

*Stand: September 2026*
`;

export const DEFAULT_MAIL_SUBJECT = "Terminvereinbarung Videosprechstunde Menopause";

export const DEFAULT_MAIL_SIGNATURE = `Mit freundlichen Grüßen
Praxis Dr. med. Inka Scheer
Nibelungenstraße 40a · 68642 Bürstadt
Tel. 06206 – 96 33 20
info@praxis-scheer.de · www.praxis-scheer.de`;

export const DEFAULT_MAIL_AUTORESPONDER = `Sehr geehrte Frau Dr. Scheer,

ich möchte gerne Ihre Videosprechstunde in Anspruch nehmen und einen Termin mit Ihnen vereinbaren.

Ich freue mich auf ein persönliches und vertrauliches Gespräch und darauf, meine Fragen und Anliegen mit Ihnen besprechen zu können.

Bitte teilen Sie mir mit, welche Termine möglich sind und ob Sie vorab noch weitere Informationen von mir benötigen.

Meine Kontaktdaten:

Name:
Telefonnummer:
eMail:

Vielen Dank für Ihre Rückmeldung.

Mit freundlichen Grüßen
`;

export const DEFAULT_POPUP = {
  enabled: "1",
  delay_seconds: 60,
  badge: "Neu in der Praxis",
  title: "Videosprechstunde – Menopause & Wechseljahre",
  text:
    "Das heutige Gesundheitssystem lässt für das so wichtige Thema Wechseljahre leider oft nicht die Zeit, die es verdient. Deshalb biete ich eine private Videosprechstunde an – damit ich mich ganz individuell und ohne Zeitdruck um Sie kümmern kann.",
  bullets: [
    "Beratung in Ihrer vertrauten Umgebung – erleichtert das Sprechen über sensible Themen",
    "Zeitlich flexibel, zeitnah und ohne lange Wartezeiten",
    "Ausführliche Vorab-Informationen per E-Mail",
    "Blutanalysen können bequem beim Hausarzt erfolgen und gemeinsam ausgewertet werden",
    "Vollständig individuelle und ganzheitliche Beratung – ganz ohne Eile",
  ].join("\n"),
  note: "Die Kosten werden nicht von der gesetzlichen Krankenversicherung übernommen. Informationen auf mehr erfahren.",
  cta_label: "Mehr erfahren",
  cta_link: "/wechseljahre",
};
